import { boxShadows, colours } from '../../../StyleConstants';
import { Box } from '@mui/system';

type Props = {
  selected?: boolean;
  label?: string;
  id?: string;
  topSubtext?: string;
  value?: string;
  checkbox?: boolean;
  centeredText?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  height?: string;
  children?: any;
  ariaLabel?: string;
  highlighted?: boolean;
  role?: string;
};

const QueryCard = ({ selected, id, ariaLabel, centeredText, disabled, onClick, onMouseLeave, onMouseEnter, highlighted, children, role, height }: Props) => {

    const backgroundColor = (selected: boolean | undefined, disabled: boolean | undefined, highlighted: boolean | undefined) => {
        if (disabled) {
            return highlighted ? colours.gray.gray10 : colours.gray.gray20
        }else {
            if (selected) return colours.orange.orange40;
            if(highlighted) {
                return colours.orange.orange15;
            }
        }
        return colours.midnightBlue.blue5;
    }

    const focusBackgroundColor = (disabled: boolean | undefined, selected: boolean | undefined) => {
        if (disabled) return colours.gray.gray20;
        if (!selected) return colours.gray.gray10;
        return colours.orange.orange40;
    }

    const hoverBackgroundColor = (disabled: boolean | undefined, selected: boolean | undefined) => {
        if (disabled){
            if(highlighted){
                return colours.gray.gray10;
            }
            return colours.gray.gray20;
        }
        if (selected) return colours.orange.orange40;
        return colours.orange.orange15;
    }

    const outline = (selected: boolean | undefined, disabled: boolean | undefined, highlighted: boolean | undefined) => {
        if(disabled) {
            if (highlighted) {
                return `2px solid ${colours.orange.orange40}`
            }else{
                return "none"
            }
        } else {
            return selected ? `2px solid ${colours.orange.orange}` : "none"
        }
    }

    const handleClick = () => {
        if(!disabled && onClick) {
            onClick();
        }
    }

    const handleKeydown = (e: { key: string; }) => {
        if(!disabled && onClick && e.key === "Enter") {
            onClick();
        }
    }

    return (
        <Box
            id={id}
            role={role ? role : "checkbox"}
            height={height}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            aria-checked={selected}
            aria-disabled={disabled}
            aria-label={ariaLabel}
            tabIndex={disabled ? -1 : 0}
            borderRadius={2}
            padding={2}
            sx={{
                textOverflow: "ellipsis",
                textWrap: "wrap",
                backgroundColor: backgroundColor(selected, disabled, highlighted),
                outline: outline(selected, disabled, highlighted),
                cursor: disabled ? "initial" : "pointer",
                wordWrap: "break-word",
                wordBreak: "break-word",
                "&:hover": {
                    boxShadow: !disabled ? boxShadows.levelTwo : "none",
                    backgroundColor: hoverBackgroundColor(disabled, selected)
                },
                ...(!highlighted && {
                    "&:focus": {
                        backgroundColor: focusBackgroundColor(disabled, selected),
                        outline: !disabled ? `2px solid ${colours.notifications.info50}` : "none"
                    },
                    "&:active": {
                        backgroundColor: !disabled ? colours.orange.orange40 : colours.gray.gray20,
                        outline: !disabled ? `2px solid ${colours.orange.orange40}` : "none"
                    }
                })

            }}
            position={"relative"}
            {...(centeredText ? { justifyContent: "center", alignItems: "center" } : {})}
            onClick={handleClick}
            onKeyDown={handleKeydown}
        >
            {children}
        </Box>
    )
}

export default QueryCard;